import { render } from "./alertesmatieres.vue?vue&type=template&id=2c2fd76f&scoped=true"
import script from "./alertesmatieres.vue?vue&type=script&lang=js"
export * from "./alertesmatieres.vue?vue&type=script&lang=js"

import "./alertesmatieres.vue?vue&type=style&index=0&id=2c2fd76f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2fd76f"]])

export default __exports__